import {
  Directive,
  ElementRef,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit
} from '@angular/core';
import { PermissionsService, AuthenticationService } from '../_services';
import isString from 'lodash/isString';
@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {
  value: string;
  notPermissionFlag: boolean;
  @Input() hasPermission = '';
  private usuario;

  constructor(
    private permissionsService: PermissionsService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authenticationService: AuthenticationService
  ) {
    console.log('constructor');
    // this.templateRef = templateRef;
  }

  toggleVisibilityBasedOnPermission(): void {
    const hasPermission = this.permissionsService.hasPermission(
      this.value,
      this.usuario
    );
    if (
      (hasPermission && !this.notPermissionFlag) ||
      (!hasPermission && this.notPermissionFlag)
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  ngOnInit(): void {
    if (!isString(this.hasPermission)) {
      throw new Error('hasPermission value must be a string');
    }
    this.value = this.hasPermission.trim();
    this.notPermissionFlag = this.value[0] === '!';
    if (this.notPermissionFlag) {
      this.value = this.value.slice(1).trim();
    }
    this.authenticationService.currentUser$.subscribe(usuario => {
      this.usuario = usuario;
      this.toggleVisibilityBasedOnPermission();
    });
  }
}
